import { render, staticRenderFns } from "./editorPage.vue?vue&type=template&id=67eb49f6&scoped=true"
import script from "./editorPage.vue?vue&type=script&lang=js"
export * from "./editorPage.vue?vue&type=script&lang=js"
import style0 from "./editorPage.vue?vue&type=style&index=0&id=67eb49f6&prod&scoped=true&lang=scss"
import style1 from "./editorPage.vue?vue&type=style&index=1&id=67eb49f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb49f6",
  null
  
)

export default component.exports